<template>
  <div>
    <nav class="nav_mobile_top topPadding">
      <div class="nav_content">
        <div class="nav_left">
          <div class="left_logo">
            <div class="back" v-if="isShowBack" @click="$emit('back')">
              <img src="@/assets/img/icon_back.b2094a45.svg" alt="" />
            </div>
            <div class="logo" style="height:0.44rem;">
              <div class="logo-container" style="width:0.44rem;height:0.44rem;flex:0 0 0.44rem;">
                <img src="@/assets/img/boryx_logo.png" alt="Boryx" style="display:block;width:100%;height:100%;object-fit:contain;" />
              </div>
              <div class="nav-title brand-stack" style="display:flex;flex-direction:column;justify-content:center;line-height:1.08;white-space:nowrap;"><span style="font-size:0.15rem;font-weight:700;letter-spacing:0.005rem;">铂域交易所</span><span style="font-size:0.13rem;font-weight:600;letter-spacing:0.01rem;">Boryx</span></div>
            </div>
          </div>
          <!-- <div class="nav_name" @click="$emit('show-drawer')">
            {{ title }}
            <img
              src="@/assets/img/icon_arrow.dc4b9070.svg"
              alt=""
              class="arrow-icon"
			  v-if="currentCode"
            />
          </div> -->
        </div>
        <div class="nav_right" v-if="showRight">
          <!-- <div class="action" @click="isLanguage = true" style="width: auto; border-radius: 5px; padding: 0 5px">
            {{ $t("navTab.language") }}
          </div>
          <div class="action sign" v-if="isLogin" @click="$router.push('/profile/notification')">
            <img src="@/assets/img/icon_bell.28bcd54a.svg" alt="" />
          </div>
          <div class="action sign" @click="openService">
            <img src="@/assets/img/service-m.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
          </div> -->
          <div class="user_name" @click="isLanguage = true">{{ $t('navTab.language') }}</div>
          <div class="action sign notice-container" v-if="showNotice" @click="$router.push('/profile/notification')">
            <img src="@/assets/img/icon_bell1.98a9a1d5.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
            <div class="notice-red-dot" v-if="hasNotice"></div>
          </div>
          <!-- <div class="action sign" v-if="showSearch" @click="openSearch">
            <img src="@/assets/img/icon_search.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
          </div> -->
          <div class="action sign" v-if="false" @click="openService">
            <img src="@/assets/img/service-m.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
          </div>
          <div class="action btn sign" @click="$router.push('/pass/login')" v-if="!isLogin && showAuthAction">
            {{ $t("login.btnLogin") }}
          </div>
        </div>
      </div>

      <div class="search-main" v-show="searchShow" @click="searchShow = false">
        <div class="content" id="content" @click.stop>
          <div class="search-input"><img src="@/assets/img/icon_search.9fcf95f5.svg" alt=""><input type="text"
              :placeholder="$t('souSuo')"></div>
          <div class="hr"></div>
          <div class="search-reault">
            <div>
              <!-- <div class="result-list">
                <div class="list-title"><img src="/images/a1af7fed02f7f6d65526b7208aaab0d2.png" alt=""> Apple Inc</div>
                <div class="list-number">$191.2418</div>
                <div class="list-cent">0.48% </div>
              </div> -->
            </div>
            <div>{{ $t('toast.nothingfound') }}</div>
          </div>
        </div>
      </div>
    </nav>

    <Languages :isPc="isPc" :isLanguage="isLanguage" @close="isLanguage = false" />
  </div>
</template>
<script>

import { getParamByKey } from '@/api/market'
import { mapState, mapGetters } from "vuex";
import Languages from "@/components/Languages.vue";

export default {
  name: "HomeView",
  data() {
    return {
      isLanguage: false,
      showDrawer: false,
      searchQuery: "",
      marketList: [],
      currentCode: "",
      searchShow: false
    };
  },
  props: {
    title: {
      type: String,
      default: "Boryx",
    },
    showRight: {
      type: Boolean,
      default: true,
    },
    showNotice: {
      type: Boolean,
      default: true,
    },
    showAuthAction: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
    showUserName: {
      type: Boolean,
      default: true,
    },
    isShowBack: {
      type: Boolean,
      default: false,
    },
    hasNotice: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["isLogin", "isPc"]),
    ...mapGetters(["getUserInfo"]),
    getTitle() {
      return this.$route.meta.title;
    },
  },
  components: {
    Languages,
  },
  mounted() {
    this.currentCode = this.$route.query.code || "";
  },
  methods: {
    openSearch() {
      this.searchShow = !this.searchShow
    },
    async openService() {
      try {
        const res = await getParamByKey('customer_service_url');
        const serviceUrl = res && res.result && res.result.paramValue;

        if (!serviceUrl) {
          console.warn('客服链接未配置');
          return;
        }

        const url = new URL(serviceUrl);
        const uid = this.getUserInfo && this.getUserInfo.id;

        if (uid != null && uid !== '') {
          url.searchParams.set('clientid', String(uid));
        }

        const link = document.createElement('a');
        link.href = url.toString();
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        console.error('获取客服链接失败', e);
      }
    },
    selectCurrency(item) {
      if (item.code === this.$route.query.code) {
        return;
      }
      this.$router.replace({
        path: "/cruuency",
        query: {
          code: item.code,
          type: item.type,
          id: item.id,
        },
      });
      this.showDrawer = false;
      this.currentCode = item.code;
    },
  },
};
</script>
<style lang="scss">
.user_name {
  font-size: .14rem;
  color: #f5c85d;
  width: .62rem;
  border-radius: .4rem;
  border: .01rem solid rgba(245, 200, 93, .82);
  box-sizing: border-box;
  height: .36rem;
  margin-left: .08rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 72% 20%, rgba(245, 200, 93, .14), transparent 32%),
    linear-gradient(180deg, rgba(10, 18, 23, .94), rgba(2, 7, 10, .98));
  box-shadow:
    inset 0 0 .16rem rgba(245, 200, 93, .08),
    0 0 .16rem rgba(245, 200, 93, .08);
}

.nav_mobile_top {
  position: fixed;
  top: 0;
  left: 0;
  /* height: 0.36rem; */
  width: 100%;
  background: #03080c;
  padding: 0.22rem 0;
  z-index: 11;
  border-bottom: .01rem solid rgba(227, 177, 74, .26);
  box-shadow: 0 .1rem .24rem rgba(0, 0, 0, .32);
}

.nav_mobile_top.topPadding {
  padding: 0.27rem 0 0.27rem 0;
}

.nav_mobile_top .nav_content {
  padding: 0 0.24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* 增强不同设备的兼容性 */
  min-height: 0.36rem;
  box-sizing: border-box;
}

.nav_mobile_top .nav_content .nav_left {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
  /* 确保在所有设备上正确对齐 */
  min-height: 0.36rem;

  .left_logo {
    display: flex;
    align-items: center;
    /* 增强垂直对齐 */
    height: 0.36rem;
    line-height: 1;
  }
}

.nav_mobile_top .nav_content .nav_left .back {
  margin-right: 0.1rem;
  width: 0.36rem;
  height: 0.36rem;
  box-sizing: border-box;
  border-radius: 50%;
  border: 0.01rem solid rgba(245, 200, 93, .78);
  background: rgba(4, 10, 14, .72);
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav_mobile_top .nav_content .nav_left .logo {
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  /* 增强垂直对齐兼容性 */
  line-height: 1;

  .logo-container {
    width: 0.36rem;
    height: 0.36rem;
    /* 修复背景图片显示问题 */
    background: none;
    background-size: contain;
    margin-right: 0.06rem;
    /* 确保在所有设备上正确显示 */
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-title {
    color: #fff;
    font-size: 0.24rem;
    font-weight: bolder;
    letter-spacing: normal;
    /* 增强垂直对齐 */
    line-height: 1.2;
    display: flex;
    align-items: center;
    /* 防止文字换行 */
    white-space: nowrap;
  }

  /* 保持向后兼容 */
  span {
    font-size: 0.24rem;
    font-weight: bolder;
    letter-spacing: normal;
    line-height: 1.2;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}

.nav_mobile_top .nav_content .nav_left .back img {
  width: 0.16rem;
  height: auto;
}

.nav_mobile_top .nav_content .nav_left .logo {
  margin-right: 0.08rem;
  height: 0.36rem;
}

.nav_mobile_top .nav_content .nav_left .logo img {
  height: 100%;
  width: auto;
}

.nav_mobile_top .nav_content .nav_left .logo span {
  color: #fff;
}

.nav_mobile_top .nav_content .nav_left .logo .brand-stack span:last-child {
  color: #f5c85d;
}

.nav_mobile_top .nav_content .nav_left .nav_name {
  /* padding-bottom: 0.04rem; */
  font-weight: 700;
  font-size: 0.22rem;
  color: #fff;
  display: flex;
  align-items: center;
  cursor: pointer;

  .arrow-icon {
    width: 0.16rem;
    height: 0.16rem;
    margin-left: 0.08rem;
  }
}

.nav_mobile_top .nav_content .nav_right {
  display: flex;
  align-items: center;
  gap: .08rem;
}

.nav_mobile_top .nav_content .nav_right .action {
  margin-left: 0;
  width: 0.36rem;
  height: 0.36rem;
  border: 0.01rem solid rgba(245, 200, 93, .82);
  background:
    radial-gradient(circle at 72% 18%, rgba(245, 200, 93, .18), transparent 32%),
    linear-gradient(180deg, rgba(10, 18, 23, .94), rgba(2, 7, 10, .98));
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow:
    inset 0 0 .16rem rgba(245, 200, 93, .08),
    0 0 .16rem rgba(245, 200, 93, .08);
}

.nav_mobile_top .nav_content .nav_right .action.btn {
  width: auto;
  border: 0.01rem solid rgba(245, 200, 93, .78);
  font-weight: 700;
  font-size: 0.22rem;
  color: #f5c85d;
  padding: 0 .12rem;
}

.nav_mobile_top .nav_content .nav_right .action.sign {
  position: relative;
  margin-left: 0;
  color: #f5c85d;
  border-color: rgba(245, 200, 93, .82);
  background:
    radial-gradient(circle at 35% 28%, rgba(255, 224, 132, .9), rgba(245, 200, 93, .55) 34%, rgba(160, 102, 24, .35) 58%, rgba(7, 12, 15, .92) 100%),
    linear-gradient(180deg, #f7d578, #b97922);
}

.nav_mobile_top .nav_content .nav_right .notice-container img {
  width: .18rem;
  height: .18rem;
  object-fit: contain;
  filter: brightness(0) saturate(100%);
}

.nav_mobile_top .nav_content .nav_right .action.sign .dot {
  position: absolute;
  top: -0.02rem;
  right: 0;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  background: #ff5858;
}

.search-main {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 12;
  line-height: 100%;
  overflow-y: auto;
}

.search-main .content {
  background: #fff;
  border-radius: 0.16rem;
  width: 3.8rem;
  min-height: 2.62rem;
  margin: auto;
  margin-top: 0.62rem;
  padding-top: 0.24rem;
  padding-bottom: 0.16rem;
  margin-bottom: 0.9rem;
}

.search-main .content .search-input {
  height: 0.26rem;
  margin: auto;
  margin-bottom: 0.1rem;
  width: 3.5rem;
}

.search-main .content .search-input input {
  width: 3.1rem;
}

.search-main .content .search-input img {
  vertical-align: middle;
}

.search-main .content .hr {
  width: 3.48rem;
  height: 0.01rem;
  border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
  margin: auto;
  margin-bottom: 0.14rem;
}

.search-main .content .search-reault {
  width: 3.5rem;
  margin: auto;
  text-align: center;
  min-height: 2rem;
  line-height: 2rem;
  font-weight: 400;
  font-size: 0.2rem;
}

.search-main .content .search-reault .result-list {
  width: 100%;
  height: 0.58rem;
  padding: 0 0.23rem 0 0.16rem;
  line-height: 0.58rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.04rem;
  background: #000;
  border-radius: 0.16rem;
}

.search-main .content .search-reault .result-list .list-title {
  font-weight: 500;
  font-size: 0.12rem;
  color: #fff;
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-title img {
  margin-right: 0.08rem;
  height: 0.22rem;
  vertical-align: middle;
}

.search-main .content .search-reault .result-list .list-number {
  font-weight: 400;
  font-size: 0.12rem;
  color: hsla(0, 0%, 100%, 0.5);
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-cent {
  font-weight: 400;
  font-size: 0.12rem;
  color: #9ee970;
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-cent1 {
  color: #ff2828;
}

.currency-drawer {
  background: #fff;

  ::v-deep .el-drawer__header {
    margin-bottom: 0 !important;
    padding: 20px;
  }

  .search-wrapper {
    padding: 0 20px;

    .market-search {
      width: 100%;

      ::v-deep .el-input__inner {
        border-radius: 4px;
        height: 36px;

        &:focus {
          border-color: #409eff;
        }
      }
    }
  }

  .drawer-content {
    padding: 0 20px;

    .market-list {
      .market-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        cursor: pointer;
        border-bottom: 1px solid #f5f5f5;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          background-color: #f5f7fa;
        }

        .item-left {
          display: flex;
          align-items: center;

          .currency-icon {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }

          .currency-name {
            font-size: 14px;
            color: #333;
          }
        }

        .item-right {
          text-align: right;

          .currency-price {
            display: block;
            font-size: 14px;
            color: #333;
            margin-bottom: 4px;
          }

          .currency-change {
            font-size: 12px;

            &.up {
              color: #67c23a;
            }

            &.down {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}

/* 通知红点样式 */
.notice-container {
  position: relative;
}

.notice-red-dot {
  position: absolute;
  top: 0.02rem;
  right: 0.02rem;
  width: 0.08rem;
  height: 0.08rem;
  background: #ff4343;
  border-radius: 50%;
  z-index: 1;
}
</style>
